import React from 'react';
import { EntradaForm } from '../components/entradas/EntradaForm';
import { createFlujosEntrada } from '../services/apis';

export const Entradas = () => <EntradaForm onCreate={createFlujosEntrada} />;
